export default interface AutoCompleteUIDTO {
  label: string;
  externalId: string;
  labelToolTip?: string;
}

export const EMPTY_AUTOCOMPLETE: AutoCompleteUIDTO = { label: "", externalId: "" };
export const ALL_AUTOCOMPLETE: AutoCompleteUIDTO = { label: "All", externalId: "All" };
